<template>
  <div>
    <div class="row-full prizes__rank">
      <div class="prizes__rank__cont">
        <div class="prizes__rank__cont__item">
          <h3>{{ getTranslations.home_prizes_and_leaderboards_rank }}<strong v-if="getRank">{{ numberFormatting(getRank.rank) }}</strong></h3>
        </div>
        <div class="prizes__rank__cont__item prizes__rank__cont__item--center">
          <h1>{{ getTranslations.home_prizes_and_leaderboards_leaderboard }}</h1>
          <img :src="userAvatar" alt="">
          <h2 v-if="getRank && getRank.displayPercentage">{{ getTranslations.home_prizes_and_leaderboards_top }} {{ getRank.displayPercentage }}%</h2>
          <h2 v-if="getRank && getRank[day] && getRank[day].displayPercentage">{{ getTranslations.home_prizes_and_leaderboards_top }} {{ getRank[day].displayPercentage }}%</h2>
          <div class="rank_update"><span>{{ getTranslations.home_prizes_and_leaderboards_last_updated }}</span> <span>{{ getDateFormat(refreshedDate, 'HH:mm') }}</span> <span>{{ getDateFormat(refreshedDate, 'MM/DD/YYYY') }} </span></div>
        </div>
        <div class="prizes__rank__cont__item">
          <h3>{{ getTranslations.home_prizes_and_leaderboards_points }}<strong v-for="(winner, index) in winners" :key="index" v-if="winner.msisdn === userDetails.msisdn">
            {{ numberFormatting(winner.points) }}
          </strong></h3>
        </div>
      </div>
      <fb-share-rank v-if="winners && getRank && facebookFunctionality"
                     :ranks="getRank"
                     :winners="winners"
                     :updatePoints="updatePoints"
                     :type="type"
                     :day="day">
      </fb-share-rank>
    </div>
    <div class="prizes__rank-list">
      <user-list :is-modal="false">
        <template slot="content">
          <virtual-list :data-key="'username'"
                        :items="getProps()"
                        :wrapperType="'favorite_user'"
                        :remain="7"
                        :estimated="150"/>
        </template>
      </user-list>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import UserList from '@/components/home/shared/GenericList';
import VirtualList from '@/components/home/shared/VirtualScrollList';
import FbShareRank from './FbShareRank';

export default {
  name: 'prize-tab',
  props: ['day', 'type', 'winners', 'getRank', 'updatePoints', 'refreshedDate', 'getDateFormat'],
  mixins: [NumbersFormattingMixin],
  components: {
    FbShareRank,
    UserList,
    VirtualList,
  },
  provide: {
    isRank: true,
  },
  methods: {
    getProps() {
      return this.winners
        .map(user => ({ ...user, isFavorite: user.favorite, active: user.msisdn === this.userDetails.msisdn }));
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
      'userAvatar',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/PrizeTab.vue